import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Col, Layout, Row} from "antd";
import styles from "./Groups.module.scss";
import {useTranslation} from "react-i18next";
import * as GroupAPI from "../../../service/group.service";
import GroupCard from "../../Group/GroupCard/GroupCard";
import SkeletonCard from "./SkeletonCard";
//@ts-ignore
import _, {isNull} from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";

import GroupContainer from "./GroupContainer";
import {requestIcon} from "../Request/request.utils.props";
import NoData from "src/components/shared/NoDataDisplay/NoData";
import CenterButton from "../../../components/shared/button/CenterButton";

const { Content } = Layout;

const Groups = (props: any) => {
  const { t } = useTranslation();
  const [myGroup, setMyGroup]: any = useState(null);
  const [favoriteGroup, setFavoriteGroup]: any = useState(null);
  const [hasMoreGroup, setHasMoreGroup]: any = useState<boolean>(true);
  const [timer, setTimer] = useState(null);
  const noDataHeaderText = t("No group available");
  const nodatatext = t("When you have groups It'll show on this pages");
  const navigate = useNavigate();

  const callLimit = 30;

  const loadMyGroup = async (search: string, limit: number, offset: number) => {
    try {
      const { data } = await GroupAPI.findMyGroup(search, limit, offset, null);
      if (data.groups === undefined) {
        data.groups = []
        data.total = 0
      }
      return data;
    } catch (e) {
      return null;
    }
  };

  const initGroupData = async () => {
    const data = await loadMyGroup("", callLimit, 0);
    const fav_data = await loadMyGroup("", 3, 0);
    // console.log("data : ", data);
    setMyGroup(data);
    setFavoriteGroup(fav_data);
    checkHasMore(data?.groups?.length, data?.total);
  };

  useEffect(() => {
    console.log("hasMoreGroup", hasMoreGroup)
  }, [hasMoreGroup])

  const searchGroup = async (event: any) => {
    const value = event.target.value;
    console.log("searchGroup => ", value);
    clearTimeout(timer!);

    setTimer(
      //@ts-ignore
      setTimeout(async () => {
        console.log("searchFriend => ", value);
        const data = await loadMyGroup(value, callLimit, 0);
        if (!_.isEmpty(data)) {
          setMyGroup(data);
        } else {
          setMyGroup({ groups: [], total: 0 });
        }
      }, 500)
    );
  };

  const checkHasMore = (currentTotal: number, total: number) => {
    if (currentTotal + callLimit >= total) setHasMoreGroup(false);
  };

  const fetchNextGroup = async () => {
    console.log("loading more...");

    checkHasMore(myGroup?.groups?.length, myGroup?.total);

    if (myGroup?.groups?.length < myGroup?.total) {
      const comingGroup = await loadMyGroup(
        "",
        callLimit,
        myGroup?.groups?.length
      );

      if (!_.isEmpty(comingGroup)) {
        setMyGroup((prev: any) => {
          const newGroupData = {
            groups: [...prev.groups, ...comingGroup.groups],
            total: prev.total,
          };
          return newGroupData;
        });
      }
    }
  };

  const checkIsMore = () => {
    if (myGroup !== null) {
      if (myGroup.groups?.length === myGroup.total) {
        setHasMoreGroup(false);
      } else {
        setHasMoreGroup(true);
      }
    }
  };

  const handleCreateGroup = () => {
    navigate("/createGroup");
  };

  useEffect(() => {
    checkIsMore();

    if (myGroup !== null) {
      console.log("public group loaded: ", myGroup.groups?.length);
    }
  }, [myGroup]);

  useEffect((): any => {
    let mounted = true;

    if (mounted) {
      initGroupData();
    }

    return () => (mounted = false);
  }, []);

  return (
    <Layout>
      <Content
        id="content-group"
        style={{
          width: "100%",
          height: "calc(100vh - 50px)",
          overflow: "auto",
          alignSelf: "center",
        }}
        className={styles.allGroupContainer}
      >
        <Row
          style={{
            minHeight: "calc(100vh - 50px)",
            backgroundColor: "#F8F8F8",
            color: "#000000",
          }}
        >
          <div
            className={styles.boxContent}
            style={{
              marginLeft: props.page === "chat" ? "252px" : "0px",
              width: props.page === "chat" ? "100%" : "100%",
            }}
          >
            <div className={styles.contentContainer}>
              <div className={styles.headerGroups}>
                <div className={styles.searchContainer}>
                  <div
                    className={styles.searchIcon}
                    style={{
                      backgroundImage: `url(${requestIcon.searchIcon})`,
                    }}
                  />
                  <input
                    type="text"
                    className={styles.searchInput}
                    placeholder={t("Search")}
                    onChange={(event) => {
                      searchGroup(event);
                    }}
                  />
                </div>

                <div className={styles.createBtn}>
                  <CenterButton
                      small
                    style={{
                      marginLeft: "3rem"
                    }}
                    onClick={handleCreateGroup}>
                    {t("Create Group")}
                  </CenterButton>
                </div>
              </div>
              <div style={{ paddingTop: 50 }}>
                <InfiniteScroll
                  dataLength={!myGroup || !myGroup.groups ? 0 : myGroup.groups?.length}
                  next={fetchNextGroup}
                  hasMore={true}
                  scrollableTarget={"content-group"}
                  loader={
                    !hasMoreGroup ? null : (
                      <div className={styles.allCardGroup}>
                        <SkeletonCard />
                      </div>
                    )
                  }
                >
                  <GroupContainer
                    header={t("All groups")}
                    number={!_.isEmpty(myGroup) ? myGroup.total : 0}
                  >
                    <div style={{ marginTop: "45px" }}>
                      <div className={styles.cardGroup}>
                        {_.isEmpty(myGroup) ? (
                          null
                        ) : (
                          myGroup?.groups.map((group: any, idx: number) => {
                            return (
                                <GroupCard
                                  key={idx}
                                  image={group.coverImgURL}
                                  member={group.totalMember}
                                  groupName={group.name}
                                  favorite={group?.groupPinUser}
                                  joined={true}
                                  groupID={group.id}
                                  onRefresh={() => {
                                    props.goChat?.();
                                  }}
                                  group={group}
                                  mainType={group.mainType}
                                  isChat={false}
                                />
                            );
                          })
                        )}
                      </div>
                      
                    </div>
                    {myGroup?.total === 0 && (
                      <NoData header={noDataHeaderText} detail={nodatatext} />
                    )}
                  </GroupContainer>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </Row>
      </Content>
    </Layout>
  );
};

export default Groups;
